/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useLayoutEffect } from 'react';
import { ROOT_PREFIX } from '../menuItem/menuItemStyles';
var DEFAULT_CHILD_ROOT_CLS = "".concat(ROOT_PREFIX, "-root");
export function useMenusScroll(refMenuList, menuScrollProps) {
  var _ref = menuScrollProps || {},
    removeScroll = _ref.removeScroll,
    menuItemParentClassName = _ref.menuItemParentClassName,
    menuItemClassName = _ref.menuItemClassName,
    _ref$maxMenuNumberInV = _ref.maxMenuNumberInView,
    maxMenuNumberInView = _ref$maxMenuNumberInV === void 0 ? 5 : _ref$maxMenuNumberInV;
  var getParentTop = function getParentTop(parent, menuList) {
    var parentTop = parent.offsetTop;
    if (parent.parentElement && parent.parentElement !== menuList) {
      parentTop += getParentTop(parent.parentElement, menuList);
    }
    return parentTop;
  };
  useLayoutEffect(function () {
    var menuList = refMenuList.current;
    if (!removeScroll && menuList) {
      var setMaxHeight = function setMaxHeight() {
        var childRootCls = menuItemClassName || DEFAULT_CHILD_ROOT_CLS;
        var parent = menuList;
        var parentTop = 0;
        if (menuItemParentClassName) {
          // For ColumnMenu, refMenuList isn't menu items' parent.
          var element = menuList.querySelector(".".concat(menuItemParentClassName));
          if (element) {
            parent = element;
            parentTop = getParentTop(parent, menuList);
          }
        }

        // For grouping, there exists some other elements, so the actual options should be filtered
        var children = [].slice.call(parent.children).filter(function (item) {
          return item.classList.contains(childRootCls);
        });
        var maxHeight = 0;
        var realMaxLength = maxMenuNumberInView;
        for (var i = 0; i < children.length; i++) {
          var _children$i;
          // somethings include Devider on MenuList, only show scrollbar when over real 5 menuItems
          if (i <= realMaxLength && !((_children$i = children[i]) !== null && _children$i !== void 0 && _children$i.classList.contains(childRootCls))) {
            realMaxLength++;
          }
        }
        var lastIndex = children.length < realMaxLength ? children.length - 1 : realMaxLength - 1;
        var lastVisibleNode = children[lastIndex];
        if (lastVisibleNode) {
          // 4 is the distance of the visible last child to the bottom of the parentNode
          maxHeight = lastVisibleNode.clientHeight + lastVisibleNode.offsetTop + 4 + parentTop;
        }
        menuList.style.maxHeight = "".concat(maxHeight, "px");
      };
      setMaxHeight();
    }
  }, []);
}